import label from "@/lang/StaticLabels.js";

// PSALE Router  - بازرگانی و فروش -----------------------------------------------
let routeItems = {
  path: "PSALE",
  name: "PSALE",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PSALEDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PSALEDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.psale,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/psale/Dashboard"),
    },
    // Base Information  -----------------------------------------------
    {
      path: "saleType",
      name: "PSALESaleType",
      meta: {
        label: label.page.saleType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/psale/base/saleType/index.vue"),
    },
    {
      path: "saleAddMinus",
      name: "PSALESaleAddMinus",
      meta: {
        label: label.page.addMinus,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "saleAddMinus/list",
      children: [
        {
          path: "list",
          name: "PSALESaleAddMinusList",
          component: () => import("@/views/modules/psale/base/saleAddMinus"),
          meta: {
            label: label.page.saleAddMinus,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSALESaleAddMinusAdd",
          component: () =>
            import("@/views/modules/psale/base/saleAddMinus/Info"),
          meta: {
            label: label.page.saleAddAddMinus,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSALESaleAddMinusEdit",
          component: () =>
            import("@/views/modules/psale/base/saleAddMinus/Info"),
          meta: {
            label: label.page.saleEditAddMinus,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "seller",
      name: "PSALESeller",
      meta: {
        label: label.page.salesManager,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/psale/base/seller/index.vue"),
    },
    {
      path: "salesAgents",
      name: "PSALESalesAgents",
      meta: {
        label: label.page.salesAgents,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/psale/base/salesAgents/index.vue"),
    },
    {
      path: "salePricePolicy",
      name: "PSALESalePricePolicy",
      meta: {
        label: label.page.salePricePolicy,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "list",
          name: "PSALESalePricePolicyList",
          component: () =>
            import("@/views/modules/psale/base/salePricePolicy/index.vue"),
          meta: {
            label: label.page.salePricePolicy,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSALESalePricePolicyAdd",
          component: () =>
            import("@/views/modules/psale/base/salePricePolicy/add.vue"),
          meta: {
            label: label.page.addSalePricePolicy,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSALESalePricePolicyEdit",
          component: () =>
            import("@/views/modules/psale/base/salePricePolicy/add.vue"),
          meta: {
            label: label.page.editSalePricePolicy,
            requiresAuth: true,
          },
        },
        {
          path: "group/:id?",
          name: "PSALESalePricePolicyGroup",
          component: () =>
            import("@/views/modules/psale/base/salePricePolicy/groupChange.vue"),
          meta: {
            label: label.page.salePricePolicyGroupChange,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "discountPolicy",
      name: "PSALEDiscountPolicy",
      meta: {
        label: label.page.discountPolicy,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "list",
          name: "PSALEDiscountPolicyList",
          component: () =>
            import("@/views/modules/psale/base/discountPolicy/index.vue"),
          meta: {
            label: label.page.discountPolicy,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSALEDiscountPolicyAdd",
          component: () =>
            import("@/views/modules/psale/base/discountPolicy/add.vue"),
          meta: {
            label: label.page.addDiscountPolicy,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSALEDiscountPolicyEdit",
          component: () =>
            import("@/views/modules/psale/base/discountPolicy/add.vue"),
          meta: {
            label: label.page.editDiscountPolicy,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "gifts",
      name: "PSALEGiftsPolicy",
      meta: {
        label: label.page.giftsPolicy,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "list",
          name: "PSALEGiftsPolicyList",
          component: () =>
            import("@/views/modules/psale/base/giftsPolicy/index.vue"),
          meta: {
            label: label.page.giftsPolicy,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSALEGiftsPolicyAdd",
          component: () =>
            import("@/views/modules/psale/base/giftsPolicy/add.vue"),
          meta: {
            label: label.page.addGiftsPolicy,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSALEGiftsPolicyEdit",
          component: () =>
            import("@/views/modules/psale/base/giftsPolicy/add.vue"),
          meta: {
            label: label.page.editGiftsPolicy,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "serviceGroup",
      name: "PSALEServiceGroup",
      meta: {
        label: label.page.serviceGroup,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/psale/base/serviceGroup"),
    },
    {
      path: "service",
      name: "PSALEService",
      meta: {
        label: label.page.service,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/psale/base/service"),
    },
    {
      path: "sampleExcelFile",
      name: "PSALESampleExcelFile",
      meta: {
        label: label.page.sampleExcelFiles,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/psale/base/sampleExcelFile"),
    },
    {
      path: "preFactor",
      name: "PSALEPreFactor",
      meta: {
        label: label.page.preFactor,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "list",
          name: "PSALEPreFactorList",
          component: () =>
            import("@/views/modules/psale/operation/preFactor/index.vue"),
          meta: {
            label: label.page.preFactor,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSALEPreFactorAdd",
          component: () =>
            import("@/views/modules/psale/operation/preFactor/add.vue"),
          meta: {
            label: label.page.addPreFactor,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSALEPreFactorEdit",
          component: () =>
            import("@/views/modules/psale/operation/preFactor/add.vue"),
          meta: {
            label: label.page.editPreFactor,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "saleFactor",
      name: "PSALESaleFactor",
      meta: {
        label: label.page.saleFactor,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "list",
          name: "PSALESaleFactorList",
          component: () =>
            import("@/views/modules/psale/operation/saleFactor/index.vue"),
          meta: {
            label: label.page.saleFactor,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSALESaleFactorAdd",
          component: () =>
            import("@/views/modules/psale/operation/saleFactor/add.vue"),
          meta: {
            label: label.page.addSaleFactor,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSALESaleFactorEdit",
          component: () =>
            import("@/views/modules/psale/operation/saleFactor/add.vue"),
          meta: {
            label: label.page.editSaleFactor,
            requiresAuth: true,
          },
        },
        {
          path: "confirmCartable",
          name: "PSALEConfirmSaleFactorCartable",
          component: () =>
            import(
              "@/views/modules/psale/operation/saleFactor/ConfirmCartable"
            ),
          meta: {
            label: label.page.confirmSaleFactorCartable,
            requiresAuth: true,
          },
        },
        {
          path: "sort",
          name: "PSALESortSaleFactor",
          component: () =>
            import("@/views/modules/psale/operation/saleFactor/Sort"),
          meta: {
            label: label.page.sortSaleFactor,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "returnSaleFactor",
      name: "PSALEReturnSaleFactor",
      meta: {
        label: label.page.returnSaleFactor,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "list",
          name: "PSALEReturnSaleFactorList",
          component: () =>
            import(
              "@/views/modules/psale/operation/returnSaleFactor/index.vue"
            ),
          meta: {
            label: label.page.returnSaleFactor,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSALEReturnSaleFactorAdd",
          component: () =>
            import("@/views/modules/psale/operation/returnSaleFactor/add.vue"),
          meta: {
            label: label.page.addReturnSaleFactor,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSALEReturnSaleFactorEdit",
          component: () =>
            import("@/views/modules/psale/operation/returnSaleFactor/add.vue"),
          meta: {
            label: label.page.editReturnSaleFactor,
            requiresAuth: true,
          },
        },
        {
          path: "confirmCartable",
          name: "PSALEConfirmReturnSaleFactorCartable",
          component: () =>
            import(
              "@/views/modules/psale/operation/returnSaleFactor/ConfirmCartable"
            ),
          meta: {
            label: label.page.confirmReturnSaleFactorCartable,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "managementCartable",
      name: "PSALEManagementCartable",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "managementCartable/receipt",
      children: [
        {
          path: "saleFactor",
          name: "PSALEManagementCartableSale",
          component: () =>
            import("@/views/modules/psale/operation/managementCartable/Sale"),
          meta: {
            label: label.page.managementCartableSale,
            requiresAuth: true,
          },
        },
        {
          path: "saleReturn",
          name: "PSALEManagementCartableSaleReturn",
          component: () =>
            import(
              "@/views/modules/psale/operation/managementCartable/SaleReturn"
            ),
          meta: {
            label: label.page.managementCartableSaleReturn,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "systemSetting",
      name: "PSALESystemSetting",
      meta: {
        label: label.page.saleSetting,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/psale/base/systemSetting"),
    },

    // Reports -----------------------------------------------
    {
      path: "reports",
      name: "PSALEReports",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "reports/salesStatisticsByCustomers",
      children: [
        {
          path: "salesStatisticsByCustomers",
          name: "PSALESalesStatisticsByCustomers",
          component: () =>
            import(
              "@/views/modules/psale/reports/customer/salesStatisticsByCustomers"
            ),
          meta: {
            label: label.page.salesStatisticsByCustomersReport,
            requiresAuth: true,
          },
        },
        {
          path: "salesQuantityReport",
          name: "PSALESalesQuantityReport",
          component: () =>
            import(
              "@/views/modules/psale/reports/commodity/salesQuantityReport"
            ),
          meta: {
            label: label.page.salesQuantityReport,
            requiresAuth: true,
          },
        },
        {
          path: "customerSalesSingleProduct",
          name: "PSALECustomerSalesSingleProduct",
          component: () =>
            import(
              "@/views/modules/psale/reports/commodity/customerSalesSingleProduct"
            ),
          meta: {
            label: label.page.customerSalesSingleProductReport,
            requiresAuth: true,
          },
        },
        {
          path: "aggregatedCustomerProductSales",
          name: "PSALEAggregatedCustomerProductSales",
          component: () =>
            import(
              "@/views/modules/psale/reports/customer/aggregatedCustomerProductSales"
            ),
          meta: {
            label: label.page.aggregatedCustomerProductSalesReport,
            requiresAuth: true,
          },
        },
        {
          path: "customerCommoditySales",
          name: "PSALECustomerCommoditySales",
          component: () =>
            import(
              "@/views/modules/psale/reports/customer/customerCommoditySales"
            ),
          meta: {
            label: label.page.customerCommoditySalesReport,
            requiresAuth: true,
          },
        },
        {
          path: "basedOnSaleManagerReport",
          name: "PSALEBasedOnSaleManagerReport",
          component: () =>
            import(
              "@/views/modules/psale/reports/salesManager/basedOnSaleManagerList"
            ),
          meta: {
            label: label.page.basedOnSaleManagerReport,
            requiresAuth: true,
          },
        },
        {
          path: "salesManagerCollaborationPercentage",
          name: "PSALESalesManagerCollaborationPercentageReport",
          component: () =>
            import(
              "@/views/modules/psale/reports/salesManager/salesManagerCollaborationPercentage"
            ),
          meta: {
            label: label.page.salesManagerCollaborationPercentageReport,
            requiresAuth: true,
          },
        },
        {
          path: "creditorsAndDebtorsBasedOnSalesManagers",
          name: "PSALECreditorsAndDebtorsReport",
          component: () =>
            import(
              "@/views/modules/psale/reports/salesManager/creditorsAndDebtors"
            ),
          meta: {
            label: label.page.creditorsAndDebtorsReport,
            requiresAuth: true,
          },
        },
        {
          path: "customerSalesBasedOnSalesManagers",
          name: "PSALECustomerSalesReport",
          component: () =>
            import("@/views/modules/psale/reports/salesManager/customerSales"),
          meta: {
            label: label.page.customerSalesReport,
            requiresAuth: true,
          },
        },
        {
          path: "productProfit",
          name: "PSALEProductProfitReport",
          component: () =>
            import("@/views/modules/psale/reports/salesProfit/productProfit"),
          meta: {
            label: label.page.productProfitReport,
            requiresAuth: true,
          },
        },
        {
          path: "grossProfit",
          name: "PSALEGrossProfitReport",
          component: () =>
            import("@/views/modules/psale/reports/salesProfit/grossProfit"),
          meta: {
            label: label.page.grossProfitReport,
            requiresAuth: true,
          },
        },
        {
          path: "productProfitByProductGroup",
          name: "PSALEProductProfitByProductGroupReport",
          component: () =>
            import(
              "@/views/modules/psale/reports/salesProfit/productProfitByProductGroup"
            ),
          meta: {
            label: label.page.productProfitByProductGroupReport,
            requiresAuth: true,
          },
        },
        {
          path: "grossProfitByInvoiceProductCustomer",
          name: "PSALEGrossProfitByInvoiceProductCustomerReport",
          component: () =>
            import(
              "@/views/modules/psale/reports/salesProfit/grossProfitByInvoiceProductCustomer"
            ),
          meta: {
            label: label.page.grossProfitByInvoiceProductCustomerReport,
            requiresAuth: true,
          },
        },
        {
          path: "salesOffice",
          name: "PSALESalesOfficeReport",
          component: () => import("@/views/modules/psale/reports/salesOffice"),
          meta: {
            label: label.page.salesOfficeReport,
            requiresAuth: true,
          },
        },
        {
          path: "saleByAgent",
          name: "PSALESaleByAgentReport",
          component: () => import("@/views/modules/psale/reports/saleByAgent"),
          meta: {
            label: label.page.saleByAgentReport,
            requiresAuth: true,
          },
        },
        {
          path: "saleReportByProduct",
          name: "PSALESaleReportByProduct",
          meta: {
            label: label.page.saleReportByProduct,
            requiresAuth: true,
          },
          component: () =>
            import(
              "@/views/modules/psale/reports/saleReportByProduct/index.vue"
            ),
        },
        {
          path: "comprehensiveCommodity",
          name: "PSALEComprehensiveCommodity",
          meta: {
            label: label.page.comprehensiveCommodityReport,
            requiresAuth: true,
          },
          component: () =>
            import(
              "@/views/modules/psale/reports/comprehensiveReport/Commodity.vue"
            ),
        },
        {
          path: "comprehensiveFactor",
          name: "PSALEComprehensiveFactorReport",
          meta: {
            label: label.page.comprehensiveFactorReport,
            requiresAuth: true,
          },
          component: () =>
            import(
              "@/views/modules/psale/reports/comprehensiveReport/Factor.vue"
            ),
        },
        {
          path: "additionsDeductions",
          name: "PSALEAdditionsDeductions",
          meta: {
            label: label.page.additionsDeductionsReports,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/psale/reports/additionsDeductions"),
        },
        {
          path: "awardsGiven",
          name: "PSALEAwardsGivenReport",
          meta: {
            label: label.page.awardsGivenReport,
            requiresAuth: true,
          },
          component: () => import("@/views/modules/psale/reports/awardsGiven"),
        },
        {
          path: "saleByVisitor",
          name: "PSALESaleByVisitorReport",
          meta: {
            label: label.page.saleByVisitorReport,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/psale/reports/saleReportByVisitor"),
        },
        {
          path: "customerProfit",
          name: "PSALECustomerProfitReport",
          meta: {
            label: label.page.customerProfitReport,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/psale/reports/customer/customerProfit"),
        },
        {
          path: "factorProfit",
          name: "PSALEFactorProfitReport",
          meta: {
            label: label.page.factorProfitReport,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/psale/reports/salesProfit/factorProfit"),
        },
      ],
    },
  ],
};

export default routeItems;
